export enum ChatRole {
  visitor = 'visitor',
  expositor = 'expositor',
}

declare global {
  interface Window {
    clearChat: () => void
    logout: () => void
    ReactNativeWebView?: {
      postMessage: (message: string) => void
    }
  }
}
